var ApplicationContextListenerScope;
(function (ApplicationContextListenerScope) {
    ApplicationContextListenerScope["MODULES"] = "modules";
    ApplicationContextListenerScope["NAVIGATION"] = "navigation";
    ApplicationContextListenerScope["OPTIONS"] = "options";
    ApplicationContextListenerScope["TITLE"] = "title";
})(ApplicationContextListenerScope || (ApplicationContextListenerScope = {}));
export default ApplicationContextListenerScope;
//# sourceMappingURL=application-context-listener-scope.js.map